import type { DSFlagName } from "@/src/design_system/primitives/flag/types/flagName";
import { ObjectValues } from "@/src/shared/types/objectValues";

export interface NormalizedBaseInputAffix {
  icon?: string | null;
  text?: string | null;
  flag?: DSFlagName | null;
  avatarUrl?: string | null;
}

export type BaseInputAffix = NormalizedBaseInputAffix | string;

export const DS_BASE_INPUT_AFFIX_TYPE = {
  Prefix: "prefix",
  Suffix: "suffix",
};

export type DSBaseInputAffixType = ObjectValues<typeof DS_BASE_INPUT_AFFIX_TYPE>;
